exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-in{\r\n    background-color: #ef3b2b;\r\n    /* background-color: #AD310B; */\r\n    -webkit-transition: background-color 1000ms linear;\r\n    transition: background-color 1000ms linear;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/comment-loader/comment-loader.component.css
// module id = ../../../../../src/app/directive/comment-loader/comment-loader.component.css
// module chunks = main